var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCleaningGold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1184_2557",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#DEA829"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1184_2557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7054 17.1924C13.4626 16.8338 13.2528 16.5253 13.0461 16.2199C13.2848 16.1584 13.4961 16.1037 13.7483 16.0391C13.9519 16.332 14.1803 16.6602 14.4211 17.0069C14.5849 16.8462 14.6536 16.6783 14.6092 16.4685C14.5415 16.1486 14.4696 15.8298 14.4097 15.5084C14.3958 15.4324 14.3921 15.3255 14.434 15.2728C14.6898 14.9519 14.9605 14.6424 15.2576 14.292C15.5501 15.7978 15.8353 17.2632 16.1247 18.7534H15.6204C15.8886 19.1477 16.1216 19.5042 16.3748 19.8458C16.4136 19.8974 16.5474 19.8923 16.6368 19.8907C17.9281 19.8711 19.1021 20.2106 20.1298 21.012C20.6724 21.4352 20.752 21.83 20.3887 22.4211C20.0482 22.975 19.5532 23.3765 19.0328 23.7491C18.3947 24.2059 17.7472 24.6477 16.9799 24.8652C16.8238 24.9097 16.6606 24.9438 16.4999 24.95C16.0095 24.9686 15.7258 24.7655 15.5692 24.2999C15.1378 23.0174 15.2308 21.7561 15.7418 20.5185C15.8085 20.3568 15.8121 20.2431 15.7067 20.0984C15.4328 19.7233 15.1667 19.3409 14.9187 18.9482C14.8205 18.7927 14.7104 18.7451 14.5399 18.7565C14.3622 18.7684 14.1834 18.7591 13.9741 18.7591C13.9741 18.9002 13.9741 19.0097 13.9741 19.1193C13.9751 20.8157 13.9746 22.5115 13.9777 24.2079C13.9782 24.4989 13.9462 24.7758 13.7431 25.0047C13.462 25.3215 13.0208 25.4362 12.6384 25.2915C12.2498 25.1448 11.9976 24.766 11.9976 24.3211C11.9966 22.573 11.9966 20.8255 11.9966 19.0774C11.9966 18.9839 11.9966 18.8903 11.9966 18.7782H11.685C11.6804 18.8841 11.6711 18.9927 11.6711 19.1012C11.6711 20.7542 11.6716 22.4077 11.6721 24.0607C11.6721 24.164 11.6742 24.2674 11.6669 24.3707C11.6246 24.9773 11.2246 25.3597 10.65 25.3463C10.0945 25.3334 9.6884 24.9071 9.68582 24.3118C9.68065 22.9342 9.68479 21.5566 9.68479 20.1791C9.68479 19.7161 9.68479 19.2531 9.68479 18.7643H7.54297C7.92018 16.8204 8.2917 14.9085 8.66633 12.9785C9.03992 13.0199 9.40111 13.0602 9.78451 13.1025C9.63518 13.7949 9.48843 14.4739 9.34168 15.1534C9.24919 15.5823 9.15256 16.0106 9.06575 16.4406C8.98928 16.8188 9.24557 17.1862 9.6171 17.1893C10.959 17.2001 12.301 17.1934 13.7054 17.1934V17.1924Z",
    fill: "url(#paint0_linear_1184_2557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9654 4.93338C13.9654 6.09652 13.0059 7.0659 11.851 7.06951C10.6697 7.07313 9.71588 6.12029 9.71484 4.93596C9.71381 3.7537 10.6723 2.79415 11.8489 2.79983C13.0079 2.80551 13.9654 3.77075 13.9654 4.93338Z",
    fill: "url(#paint1_linear_1184_2557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1918 8.09185C15.4474 8.72897 16.3026 10.0187 16.2132 11.3818C16.146 12.407 15.7223 13.2973 15.1193 14.0972C14.691 14.6656 14.2006 15.189 13.718 15.7135C13.4141 16.0432 13.0049 16.0597 12.7377 15.7972C12.4675 15.5316 12.4902 15.1332 12.8059 14.816C13.409 14.2104 13.981 13.58 14.4083 12.8338C14.7555 12.2272 15.0098 11.5942 14.8976 10.8703C14.8439 10.5215 14.6925 10.2249 14.4269 9.97376C14.4941 10.3246 14.5447 10.6796 14.6326 11.0253C14.7282 11.4025 14.6987 11.7642 14.5416 12.1083C14.3752 12.4721 14.1778 12.8219 13.9939 13.178C13.9665 13.1728 13.9386 13.1676 13.9112 13.1625C13.844 12.8767 13.7758 12.591 13.7107 12.3047C13.6725 12.1368 13.6585 11.9616 13.6022 11.8004C13.3831 11.1715 13.4456 10.5628 13.6554 9.94172C13.8585 9.34026 14.0115 8.72174 14.1918 8.09082V8.09185Z",
    fill: "url(#paint2_linear_1184_2557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5716 11.4228C10.0084 11.3943 9.51076 11.369 9.03176 11.3453C8.96665 10.9711 9.29632 10.6482 8.95115 10.2829C8.78993 10.5567 8.63491 10.7975 8.50418 11.0507C8.41686 11.2197 8.48196 11.3649 8.66953 11.4088C8.96148 11.4775 9.25653 11.5488 9.55365 11.5721C9.9045 11.5995 10.259 11.5783 10.6119 11.5767C11.0325 11.5752 11.3177 11.815 11.3327 12.186C11.3487 12.5745 11.0837 12.8474 10.6522 12.8649C9.86885 12.897 9.08446 12.9228 8.32695 12.6582C7.26818 12.2888 6.88477 11.3974 7.38393 10.3981C7.55496 10.0555 7.77819 9.72894 8.02828 9.43854C8.20138 9.23702 8.1895 9.11352 8.04688 8.91717C7.69293 8.43041 7.36016 7.92919 7 7.40627C7.18757 7.27605 7.36067 7.15617 7.56375 7.01562C7.95077 7.57627 8.32953 8.12606 8.72121 8.69394C8.97078 8.49965 9.21003 8.31312 9.48441 8.09919C9.60945 8.53376 9.72572 8.92595 9.83423 9.31969C9.97994 9.85037 10.1096 10.3857 10.2683 10.9122C10.3153 11.0683 10.4372 11.2016 10.5721 11.4228H10.5716Z",
    fill: "url(#paint3_linear_1184_2557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96536 7.79807C11.2262 7.38417 12.4436 7.42913 13.6961 7.79497C13.632 8.03886 13.5783 8.25382 13.5189 8.46671C13.322 9.16997 13.1169 9.87116 12.9277 10.577C12.8812 10.7496 12.8073 10.81 12.6265 10.8064C12.085 10.7951 11.5429 10.8085 11.0009 10.7992C10.927 10.7982 10.8056 10.7382 10.789 10.6814C10.51 9.73526 10.2444 8.78501 9.96484 7.79858L9.96536 7.79807Z",
    fill: "url(#paint4_linear_1184_2557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7356 14.5526C12.5909 14.7629 12.4618 14.951 12.3171 15.1608C11.8448 14.4715 11.3658 13.7718 10.8945 13.083C11.0847 12.9466 11.2552 12.8241 11.4516 12.6836C11.8753 13.3 12.3093 13.9325 12.7356 14.5526Z",
    fill: "url(#paint5_linear_1184_2557)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1184_2557",
    x1: 14.0769,
    y1: 12.9785,
    x2: 14.0769,
    y2: 25.3533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1184_2557",
    x1: 11.8401,
    y1: 2.7998,
    x2: 11.8401,
    y2: 7.06952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1184_2557",
    x1: 14.3852,
    y1: 8.09082,
    x2: 14.3852,
    y2: 15.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1184_2557",
    x1: 9.16671,
    y1: 7.01562,
    x2: 9.16671,
    y2: 12.8845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1184_2557",
    x1: 11.8305,
    y1: 7.50391,
    x2: 11.8305,
    y2: 10.8066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1184_2557",
    x1: 11.8151,
    y1: 12.6836,
    x2: 11.8151,
    y2: 15.1608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaningGold);
export default __webpack_public_path__ + "static/media/cleaning_gold.973cbcae18505bd8b27fa9d56121e79e.svg";
export { ForwardRef as ReactComponent };